<div class="wrapper">
    <p>Config enviroment</p>
    <mat-icon class="icon-size">settings</mat-icon>
    <span>{{this.enviromentContextService.packingStation | async | nullWithDefault:'Station not selected' }}</span>
</div>